// apps/vendor/src/lib/queryClient.ts
//
// Vendor-portal TanStack Query client, extracted from `main.tsx` so
// non-component code (the session-teardown wiring below) can reach the same
// instance. Config is byte-identical to what `main.tsx` declared inline.
//
// Why extracted: logging out and signing in as a DIFFERENT vendor in the same
// tab showed the previous account's data until a full F5. `useAuth().logout()`
// (packages/ui/src/hooks/useAuth.ts:252) only resets its own zustand store —
// it never touches the query cache, so every cached list/detail from the prior
// session stayed in memory and rendered for the new account.
//
// admin and merchant-v3 already clear on logout:
//   • apps/admin/src/stores/useAuthStore.ts:393     (dbg-20260720)
//   • apps/merchant-v3/src/lib/auth/AuthProvider.tsx:177  (dbg-20260602 iter10)
// vendor was the one portal left out.

import { QueryClient } from '@tanstack/react-query';

/**
 * Canonical vendor-portal QueryClient. Single instance so
 * `<QueryClientProvider client={queryClient}>` consumers share one cache.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

export default queryClient;
